angular.module('app').controller('GamesLabelPopupController', [
    '$scope', '$uibModalInstance', 'initialLabel','casinoLabels',
    function ($scope, $modalInstance, initialLabel,casinoLabels) {
        $scope.state = {
            label: initialLabel || ""
        };
        $scope.labels = casinoLabels;

        $scope.save = function () {
            $modalInstance.close($scope.state.label);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);
